import styled from "styled-components";

const Block = styled.div`
    flex: 1;
    color: #fff;
    padding-top: 1%;
    align-content: center;

    `;
export default Block;